import {NgModule} from '@angular/core';
import {PreloadAllModules, Route, RouterModule, Routes, UrlMatchResult, UrlSegment, UrlSegmentGroup} from '@angular/router';
import {AppLayoutComponent, MustBeAuthenticatedGuard} from './shared';
import {RolesService} from './shared/services/roles.service';
import {InternalUserGuard} from './shared/guards/internal-user.guard';

export function contextId(segments: UrlSegment[], segmentGroup: UrlSegmentGroup, route: Route): UrlMatchResult {
  const parts: RegExp[] = [/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i];
  const posParams: { [key: string]: UrlSegment } = {};
  const consumed: UrlSegment[] = [];

  let currentIndex = 0;
  for (let i = 0; i < parts.length; ++i) {
    if (currentIndex >= segments.length) {
      return null;
    }
    const current = segments[currentIndex];

    const part = parts[i];
    if (!part.test(current.path)) {
      return null;
    }
    if (segments[1].path !== 'contracts' ) {
      posParams['clientId'] = current;
    } else {
      posParams['companyId'] = current;
    }
    consumed.push(current);
    currentIndex++;
  }

  if (route.pathMatch === 'full' && (segmentGroup.hasChildren() || currentIndex < segments.length)) {
    return null;
  }
  return {consumed, posParams};
}

const routes: Routes = [{
  path: '',
  component: AppLayoutComponent,
  children: [
    {path: '', redirectTo : '/clients/list', pathMatch: 'full'},
    {path: 'clients', loadChildren: 'app/client/client.module#ClientModule'},
    {path: 'orders', loadChildren: 'app/order/order.module#OrderModule'},
    {path: 'reports', loadChildren: 'app/report/report.module#ReportModule'},
    {path: 'anomalies', loadChildren: 'app/anomaly/anomaly.module#AnomalyModule'},
    { path: 'shippings',
      data: { roles: 'BO_SHIPPING_VIEW', title: '' },
      // canActivate: [RoleCanActivateGuard],
      loadChildren: 'app/shipping/shipping.module#ShippingModule'
    },
    {
      path: 'companies',
      data: { roles: 'BO_BILLING_VIEW', title: '' },
     // canActivate: [RoleCanActivateGuard],
      loadChildren: 'app/company/company.module#CompanyModule'
    },
    {
      path: 'invoices',
      data: { roles: 'BO_BILLING_INVOICES_VIEW', title: '' },
      // canActivate: [RoleCanActivateGuard],
      loadChildren: 'app/invoices/invoices.module#InvoicesModule'
    },
    {
      path: 'dashboard',
      data: { roles: 'BO_BILLING_VIEW', title: '' },
      loadChildren: 'app/dashboard/dashboard.module#DashboardModule'
    },
    {
      matcher: contextId,
      children:
        [
          {path: 'orders', loadChildren: 'app/order/order.module#OrderModule' },
          {path: 'dashboard', loadChildren: 'app/dashboard/dashboard.module#DashboardModule'},
          {path: 'clients', loadChildren: 'app/client/client.module#ClientModule'},
          {path: 'sites', loadChildren: 'app/site/site.module#SiteModule'},
          {path: 'anomalies', loadChildren: 'app/anomaly/anomaly.module#AnomalyModule'},
          {path: 'contracts', loadChildren: 'app/contract/contract.module#ContractModule', data: { roles: 'BO_BILLING_VIEW', title: '' } },
        ]
    }
  ],
  data: {role: 'USERS'},
  canActivate: [MustBeAuthenticatedGuard],
  resolve: { roles: RolesService }
}];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, relativeLinkResolution: 'legacy' })],
  exports: [RouterModule], providers: []
})
// @NgModule({ imports: [RouterModule.forRoot(routes, { enableTracing: !environment.production })], exports: [RouterModule], providers: [] })
export class AppRoutingModule {
}
